import { array, object } from 'yup';

const schema = object({
    items: array().of(object()).notInEdit('Finish editing of an option card'),
});

export default schema;
